import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

const SETOR_COLORS: Record<string, { bg: string; border: string; text: string }> = {
  'Sucesso do Cliente': { bg: 'rgba(139, 92, 246, 0.08)', border: '#8b5cf6', text: '#a78bfa' },
  Performance: { bg: 'rgba(245, 158, 11, 0.08)', border: '#f59e0b', text: '#fbbf24' },
  Marketing: { bg: 'rgba(94, 106, 210, 0.08)', border: '#5e6ad2', text: '#818cf8' },
  Operações: { bg: 'rgba(34, 197, 94, 0.08)', border: '#22c55e', text: '#4ade80' },
  Criação: { bg: 'rgba(236, 72, 153, 0.08)', border: '#ec4899', text: '#f472b6' },
  Projetos: { bg: 'rgba(14, 165, 233, 0.08)', border: '#0ea5e9', text: '#38bdf8' },
  Tecnologia: { bg: 'rgba(99, 102, 241, 0.08)', border: '#6366f1', text: '#818cf8' },
  'Gestão / RH': { bg: 'rgba(168, 85, 247, 0.08)', border: '#a855f7', text: '#c084fc' },
  Outros: { bg: 'rgba(148, 163, 184, 0.08)', border: '#94a3b8', text: '#cbd5e1' },
}

export function groupMapaCargosBySetor(cargos: MapaCargo[]): Record<string, MapaCargo[]> {
  return cargos.reduce<Record<string, MapaCargo[]>>((acc, cargo) => {
    const key = cargo.setor.trim() || 'Outros'
    acc[key] = acc[key] ?? []
    acc[key].push(cargo)
    return acc
  }, {})
}

export function countMapaCargoSecoes(cargo: MapaCargo): number {
  return cargo.secoes.length
}

export function countMapaCargoAtividades(cargo: MapaCargo): number {
  return cargo.secoes.reduce((sum, secao) => sum + secao.atividades.length, 0)
}

export function getMapaCargoSetorColors(setor: string) {
  return SETOR_COLORS[setor] ?? SETOR_COLORS.Outros
}
